/* tslint:disable */
/* eslint-disable */
/**
 * Import Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';

import type { ReferencedWorkDTO } from './ReferencedWorkDTO';
import {
    ReferencedWorkDTOFromJSON,
    ReferencedWorkDTOFromJSONTyped,
    ReferencedWorkDTOToJSON,
    ReferencedWorkDTOToJSONTyped,
} from './ReferencedWorkDTO';

/**
 * 
 * @export
 * @interface WorkRelatedIdentifierInternalDTO
 */
export interface WorkRelatedIdentifierInternalDTO  {
    /**
     * 
     * @type {number}
     * @memberof WorkRelatedIdentifierInternalDTO
     */
    id?: number;
    /**
     * 
     * @type {ReferencedWorkDTO}
     * @memberof WorkRelatedIdentifierInternalDTO
     */
    referencedWork?: ReferencedWorkDTO;
    /**
     * 
     * @type {string}
     * @memberof WorkRelatedIdentifierInternalDTO
     */
    relationType?: string;
}

/**
 * Check if a given object implements the WorkRelatedIdentifierInternalDTO interface.
 */
export function instanceOfWorkRelatedIdentifierInternalDTO(value: object): value is WorkRelatedIdentifierInternalDTO {
    return true;
}

export function WorkRelatedIdentifierInternalDTOFromJSON(json: any): WorkRelatedIdentifierInternalDTO {
    return WorkRelatedIdentifierInternalDTOFromJSONTyped(json, false);
}

export function WorkRelatedIdentifierInternalDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): WorkRelatedIdentifierInternalDTO {
    if (json == null) {
        return json;
    }
    return {
        
                  'id': json['id'] == null ? undefined : json['id'],
                  'referencedWork': json['referencedWork'] == null ? undefined : ReferencedWorkDTOFromJSON(json['referencedWork']),
                  'relationType': json['relationType'] == null ? undefined : json['relationType'],
    };
}

export function WorkRelatedIdentifierInternalDTOToJSON(json: any): WorkRelatedIdentifierInternalDTO {
    return WorkRelatedIdentifierInternalDTOToJSONTyped(json, false);
}

export function WorkRelatedIdentifierInternalDTOToJSONTyped(value?: WorkRelatedIdentifierInternalDTO | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'referencedWork': ReferencedWorkDTOToJSON(value['referencedWork']),
        'relationType': value['relationType'],
    };
}


